import React from 'react'
import { compose, branch, renderComponent, withProps } from 'recompose'
import CircularProgress from 'material-ui/CircularProgress'
import glamorous from 'glamorous'
import Subheader from 'material-ui/Subheader'

const Loader = ({ className, loadingMessage }) => (
  <div className={className}>
    <CircularProgress
      size={60}
      thickness={6}
    />
    <Subheader>{loadingMessage}</Subheader>
  </div>
)

const StyledLoader = glamorous(Loader)({
  paddingTop: 100,
  paddingBottom: 100,
  backgroundColor: 'rgba(0, 0, 0, 0.05)',
  textAlign: 'center',
})

const withLoading = ({
  getIsLoading = () => false,
  getMessage = () => '',
}) => (
  compose(
    branch(
      getIsLoading,
      renderComponent(
        withProps((props) => ({
          loadingMessage: getMessage(props)
        }))(StyledLoader)
      ),
    ),
  )
)

export default withLoading



// WEBPACK FOOTER //
// ./src/hocs/bases/withLoading.js